<template lang="pug">

  div

    //-
      -
      - Modal GERAR RELATÓRIO DE HORAS
      -
      -

    v-dialog(
      content-class="dialogRelatorio"
      v-if="dialog === true && reportStatus === 'loaded' && this.duties.length > 0"
      v-model="dialog"
      :persistent="exportingExcel"
      max-width="1680px")

      .dialogHeader(style="font-size: 16px")

        .dialogHeaderTitle
          span {{ months[month] + ' de ' + year }}
            span(:style="{ opacity: 0.5 }") &nbsp;(horas trabalhadas por dia)

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeRelatorioHorasDialog()")

      .dialogBody.timeReportDialogBody(style="padding: 0; overflow-y: scroll; max-height: 400px; font-size: 16px")

        .dialogBodyContent

          .ml-5.mt-2
            label.csLabel
              span
                | Período
            .csFields.csFields--date
              date-picker(v-model="dateRange" :clearable="false" :disabled-date="disableDatesCondition" range valueType="format" format="DD/MM/YYYY" :lang="lang" class="groupUserField--date" :disabled="loading")

            sos-button(@buttonClick="exportExcel" buttonLabel="EXPORTAR PARA EXCEL" color="lightblue" buttonIcon="mdi-microsoft-excel" buttonIconSize="20" :loading="exportingExcel" size="medium").mt-5

          .relatorio-tables
            table.rel-table-users(cellspacing="0", cellpadding="0")
              thead
                tr
                  th.rel-table-users-th-top-cl1
                    span -
                  th.rel-table-users-th-top-cl2
                    span -
                tr
                  th.rel-table-users-th-bottom-cl1
                    span Usuário
                  th.rel-table-users-th-bottom-cl2
                    span Quantidade
              tbody

                tr(v-for="(item, index) in tableData", :key="index" :class="{ 'bgTotal': index === tableData.length -1 }")
                  td.rel-table-users-cl1
                    span(
                      v-if="item.name !== 'Disponíveis' && item.name !== 'Total'"
                    )
                      abbr(:title="item.name") {{ item.name }}
                    span(v-else) {{ item.name }}
                  //- td.rel-table-users-cl1
                    span(
                      v-if="item.name !== 'Disponíveis' && item.name !== 'Total'"
                    )
                      abbr(:title="item.name") {{ fixedName(item.name) }}
                    span(v-else) {{ fixedName(item.name) }}
                  td(
                    :class="index === 0 ? 'rel-table-users-cl2-first' : 'rel-table-users-cl2'"
                  )
                    span(
                      :class="index === 0 ? 'qnt_disponiveis' : 'qnt_usuario'"
                    ) {{ item.qtd || 0 }}

            .rel-table-calendar
              table(cellspacing="0", cellpadding="0")
                thead
                  tr
                    th(
                      v-for="(num, index) in [...daysInMonth]",
                      :class="'rel-table-calendar-th-top' + (daysInMonth.length - 1 === index ? ' last' : '')"
                    )
                      span {{ num.day_name }}
                  tr
                    th(
                      v-for="(num, index) in [...daysInMonth]",
                      :class="'rel-table-calendar-th-bottom' + (daysInMonth.length - 1 === index ? ' last' : '')"
                    )
                      span {{ num.day_number }}
                tbody
                  tr(v-for="(item_table, item_table_index) in tableData" :class="{ 'bgTotal': item_table_index === tableData.length -1 }")
                    td(
                      v-for="(item, item_index) in [...daysInMonth]",
                      :class="(item_table_index === 0 && item_table[item.value] !== undefined ? 'highlight' : '') + (daysInMonth.length - 1 === item_index ? ' last' : '')"
                    )
                      span(v-if="typeof item_table[item.value] === 'object'" :class="!!item_table[item.value].highlight === true ? 'highlight_red' : ''") {{ item_table[item.value].durationInSeconds > 0 ? item_table[item.value].formattedDurationHourAndMinutes : '&nbsp;' }}
                      span(v-else v-html="'&nbsp;'")

            table.rel-table-totalhoras(cellspacing="0", cellpadding="0")
              thead
                tr
                  th.rel-table-totalhoras-th-top
                    span -
                tr
                  th.rel-table-totalhoras-th-bottom
                    span Total
              tbody
                tr(v-for="(item_table, item_table_index) in tableData" :key="item_table_index" :class="{ 'bgTotal': item_table_index === tableData.length -1 }")
                  td
                    span {{ item_table.total || 0 }}

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")

    //-
      -
      - Modal INSCRIÇÃO / ASSINATURA
      -
      -

    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")

</template>

<script>

  import { mapState } from 'vuex'

  import dateTimeLanguage from '@/constants/dateTimeLanguage'
  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport } from '@/services/report'

  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import { parseDate, formatDate, isValidDate, timestrToSec, formatSecondsToTime, formatDuration, formatDurationForTable } from '@/mixins/utils'
  import { valueToTime } from '@/functions'

  import lang from '@/locales/pt_BR.json'

  import SosButton from '@/components/SosButton'
  import SubscriptionModal from '@/modals/SubscriptionModal'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import { getGroupByID, getUserByID/* , apiGetScaleDuties */ } from '@/services/firebase'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  // Moment JS
  import moment from 'moment'
  import 'moment/locale/pt-br'

  //
  //
  //

  export default {
    name: 'ExportScaleHoursModal',

    components: {
      SubscriptionModal,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'date-picker': DatePicker,
    },

    mixins: [
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],

    /* props: {
      year: {
        type: Number,
        default: () => null,
      },
      month: {
        type: Number,
        default: () => null,
      },
    }, */

    data () {
      return {
        exportingExcel: false,
        reportStatus: 'loading',
        loading: false,
        group: null,
        users: [],
        duties: [],

        // DATE RANGE
        dateRange: null,

        nameMaxLength: 12, // 14,
        // nameMaxLength: 16, // 14,
        itemsPerPage: -1, // 5,

        tableData: [],

        tabelaDisponiveis: [],
        tabelaUsuarios: [],
        tabelaTotais: [],

        // Paginação
        windowHeight: window.innerHeight,
        page: 1,
        pagination: {
          pageSize: 7,
          currentPage: 1,
          pageTotalItens: 0,
          totalPages: 0,
          pageStart: 0,
          pageStop: 3,
        },
        options: {
          align: 'center',
          sortable: false,
        },

        months: lang.months,
        weekDays: lang.weekDays,

        // Dialogs
        dialog: false,
        // loadingTimeReport: false,

        // DATE PICKER SETTING
        lang: dateTimeLanguage,
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
      }),

      headers () {
        const { $vuetify, daysInMonth, options } = this

        daysInMonth.map((item) => {
          item.text = item.text
            .replace(/(?:\r\n|\r|\n)/g, '<br>')
            .replace(/(?:\(|\))/g, '')
        }) // [03/12/2020] Firmino

        return $vuetify.breakpoint.mdAndUp
          ? daysInMonth
          : [
            {
              text: 'Usuário',
              value: 'name',
              ...options,
            },
            {
              text: 'QTD',
              value: 'qtd',
              ...options,
            },
            ...daysInMonth,
            {
              text: 'Total',
              value: 'total',
              ...options,
            },
          ]
      },

      daysInMonth () {
        // const date = new Date()
        const days = []

        for (let i = 1; i <= this.lastDayOfMonth; i++) {
          // const weekDay = new Date(date.getFullYear(), this.month, i).getDay()
          const weekDay = new Date(this.year, this.month, i).getDay()
          const weekDayName = this.weekDays[weekDay].abbr

          days.push({
            // text: `(${weekDayName})\n${i.toString()}`,
            day_name: weekDayName,
            day_number: i.toString(),
            text: `${weekDayName}<br>${i.toString()}`,
            value: i.toString(),
            align: 'center',
            sortable: false,
          })
        }

        return days
      },

      /* currentMonth () {
        return new Date().getMonth() + 1
      }, */

      lastDayOfMonth () {
        // const date = new Date()
        // const year = date.getFullYear()
        const { year, month } = this
        return new Date(year, month + 1, 0).getDate()
      },
    },

    /* watch: {
      dateRange: {
        immediate: true,
        handler (newRange, oldRange) {
          // [24/01/25] console.log('::: WATCHING DATE RANGE:', oldRange, newRange)
        },
      },
    }, */

    mounted () {
      // moment init
      moment.locale('pt-BR')
    },

    methods: {

      //
      //
      //
      // DESABILITA TODAS AS DATAS ANTERIORES A 2016
      // CONSIDERAR FUSO HORÁRIO?
      //
      //
      //

      disableDatesCondition (date, currentValue) {
        return date < new Date(2016, 0, 1)
      },

      //
      //
      //
      // OPEN MODAL
      //
      //
      //

      /**
       *
       * MOSTRAR MENSAGEM RELACIONADA AO STATUS DO PLANO
       *
       */

      showPlanMessage () {
        const planName = this.userSession.planName.name

        const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo gerar o relatório de horas. Preciso de ajuda." target="_blank">suporte</a>`
        const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

        if (this.userSession.planOrigin === 'CUSTOM') {
          // Plano personalizado
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas o relatório de horas não está liberado.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'COUPON') {
          // Cupom ativo
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas o relatório de horas não está liberado.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          // Assinatura ativa na vindi
          this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para gerar o relatório de horas, assine o Plano Silver ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          // Assinatura ativa, mas com alguma pendência ou erro na vindi
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e o relatório de horas não está liberado.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            // Plano da vindi expirado
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e o relatório de horas não está liberado.</p>${textSupport}`)
          } else {
            // Plano gratuíto ou alcançou alguma condição desconhecida
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e o relatório de horas não está liberado.</p>${textSupport}`)
          }
        }
      },

      /**
       *
       * ABRIR
       *
       */

      open (p)
      {
        if (this.exportingExcel || this.loading) return false

        //
        //
        //

        if (freeVersion === false && this.userSession.userCapabilities.relatorioHoras !== true)
        {
          this.showPlanMessage()

          return false
        }

        //
        //
        //

        // this.loadingTimeReport = true

        this.year = p.year
        this.month = p.month
        this.duties = p.shifts

        //
        // SET THE CURRENT RANGE BASED IN THE SELECTED MONTH/YEAR AT THE PREVIOUS SCREEN
        //

        // Get the first day of the current month
        var firstDay = new Date(p.year, p.month, 1)
        // Get the last day of the current month
        var lastDay = new Date(p.year, p.month + 1, 0)

        // Format and output the first and last day
        this.dateRange = [formatDate(firstDay), formatDate(lastDay)]

        // [24/01/25] console.log('::: Relatorio de Horas:', p)

        this.dialog = true

        this.loadData()
      },

      closeRelatorioHorasDialog () {
        if (this.exportingExcel) return false

        this.dialog = false

        this.reportStatus = 'loading'
        this.group = null
        this.users = []
        this.duties = []
        this.tableData = []

        this.tabelaDisponiveis = []
        this.tabelaUsuarios = []
        this.tabelaTotais = []

        this.page = 1
        this.pagination = {
          pageSize: 7,
          currentPage: 1,
          pageTotalItens: 0,
          totalPages: 0,
          pageStart: 0,
          pageStop: 3,
        }
      },

      /**
       *
       * EXPORT WITHOUT OPEN
       *
       */

      async outerExport (p)
      {
        if (this.exportingExcel || this.loading) return false
        // if (this.exportingExcel) return false

        //
        //
        //

        if (freeVersion === false && this.userSession.userCapabilities.relatorioHoras !== true)
        {
          this.showPlanMessage()

          return false
        }

        //
        //
        //

        // this.loadingTimeReport = true

        this.year = p.year
        this.month = p.month
        // this.duties = p.shifts

        //
        // SET THE CURRENT RANGE BASED IN THE SELECTED MONTH/YEAR AT THE PREVIOUS SCREEN
        //

        // Get the first day of the current month
        var firstDay = new Date(p.year, p.month, 1)
        // Get the last day of the current month
        var lastDay = new Date(p.year, p.month + 1, 0)

        // Format and output the first and last day
        this.dateRange = [formatDate(firstDay), formatDate(lastDay)]

        // [24/01/25] console.log('::: Relatorio de Horas:', p)

        //
        //
        //

        this.$emit('setButtonState', true)
        this.exportingExcel = true

        try
        {
          const checkEndpoint = this.$route.params.scaleID ? `checktimereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}` : `checkgrouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}`
          const generateUrl = this.$route.params.scaleID ? `timereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}` : `grouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}`

          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.exportingExcel = false
        this.$emit('setButtonState', false)
      },

      /**
      *
      * ?
      *
      */

      async exportExcel ()
      {
        if (this.exportingExcel) return false

        //
        // VALIDATE DATE RANGE
        //

        const isItValid = Array.isArray(this.dateRange) && this.dateRange.length === 2 && isValidDate(this.dateRange[0]) && isValidDate(this.dateRange[1])

        if (!isItValid) return this.showMessage('Atenção!', 'Selecione o período do relatório de horas')

        //
        // VALIDATE DATE RANGE SIZE
        //

        const firstDateObj = parseDate(this.dateRange[0])
        const lastDateObject = parseDate(this.dateRange[1])
        const differenceInDays = Math.floor((lastDateObject - firstDateObj) / (1000 * 60 * 60 * 24))

        // this.showMessage('Atenção!', 'Você pode selecionar até dois meses para gerar uma folha de pagamento')
        if (differenceInDays > 62) return this.showMessage('Atenção!', 'Você pode selecionar até dois meses')

        //
        //
        //

        this.exportingExcel = true

        try
        {
          const checkEndpoint = this.$route.params.scaleID ? `checktimereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}` : `checkgrouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}`
          const generateUrl = this.$route.params.scaleID ? `timereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}` : `grouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}`

          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.exportingExcel = false
      },

      /**
      *
      * Funções utilitárias
      *
      */

      // Verifica se o plantão foi registrado no mês atual
      checkDutyByYearMonth (duty) {
        const tz = duty.dutyStartDateTZ || ''
        const date = tz === '+0000' ? moment.utc(duty.data_inicio) : moment(duty.data_inicio)

        const dutyMonth = parseInt(date.format('M'))
        const dutyYear = parseInt(date.format('YYYY'))

        return dutyMonth === (this.month + 1) && dutyYear === this.year
      },

      // Valida se o plantão pertence ao mês atual e ao usuário especificado
      userDutyFilter (duty, user) {
        return this.checkDutyByYearMonth(duty) && duty.uid_pegou === user.uid
      },

      // Valida se o plantão pertence ao mês atual e é de tipo "Disponível"
      availableDutyFilter (duty) {
        return (
          this.checkDutyByYearMonth(duty) &&
          duty.status !== 'cancelado' &&
          duty.status !== 'fechado' &&
          duty.uid_pegou === 0
        )
      },

      // Limita o tamanho de nomes em até 25 caracteres (definido em nameMaxLength)
      fixedName (string) {
        const { nameMaxLength } = this
        return string.length > nameMaxLength ? `${string.substr(0, nameMaxLength)}...` : string
      },

      /**
      *
      * Aqui inicia o carregamento da tabela, primeiro os grupos, em seguida a lista de usuários, em seguida os plantões e por último a tabela toda (no método loadTableData)
      *
      */

      async loadData () {
        const { groupID } = this.$route.params

        if (!groupID) {
          // [24/01/25] console.log('::: loadData: groupID ausente')
          return false
        }

        this.$emit('setButtonState', true)
        this.loading = true
        this.users = []

        /* const monthToRead = this.month + 1
        const yearToRead = this.year */

        // [24/01/25] console.log(`::: loadData: CARREGANDO O GRUPO ${groupID}...`)

        /* GRUPO + USUÁRIOS DO GRUPO */

        const group = await getGroupByID(groupID)
        const usersKeys = !!group && !!group.users ? Object.keys(group.users) : []

        this.group = group

        if (usersKeys.length === 0) {
          // [24/01/25] console.log('::: loadData: NÃO FOI POSSÍVEL CARREGAR GRUPO E USUÁRIOS DO GRUPO')
          this.$emit('setButtonState', false)
          this.loading = false
          return false
        }

        const users = (await Promise.all(
          usersKeys.map(async userId => {
            if (!!userId === false) return false
            const user = await getUserByID(userId)
            if (!!user === false) return false
            user.shortName = this.fixedName(user.nome)
            // user.shortName = nomeAbrev(user.nome)
            return user
          })
        )).filter(user => !!user)

        this.users = users

        // [24/01/25] console.log(`::: loadData: ${users.length} USUÁRIOS FORAM CARREGADOS`)

        // console.log(`::: loadData: ${users.length} USUÁRIOS FORAM CARREGADOS, CARREGANDO PLANTÕES DA ESCALA EM ${monthToRead}/${yearToRead}...`)

        //
        // PLANTÕES
        //

        //
        //
        //

        /* let duties = await apiGetScaleDuties(scaleID, monthToRead, yearToRead)
        duties = duties ? Object.values(duties) : []
        this.duties = shifts */

        //
        //
        //

        this.$emit('setButtonState', false)
        this.loading = false
        this.reportStatus = 'loaded'

        // [24/01/25] console.log(`::: loadData: ${this.duties.length} PLANTÕES DA ESCALA FORAM CARREGADOS, MONTANDO TABELA...`)

        if (this.duties.length === 0) {
          this.showMessage('Atenção!', `Não há plantões em ${this.months[this.month]} de ${this.year}`)
        }

        //
        // CARREGAR TABELA
        //

        const { getAvailablesRow, getUserRows, getTotalsRow } = this

        // [10/12/2020] Firmino - Tarefa 1 [Refatoração para Paginação]
        this.tabelaDisponiveis = getAvailablesRow()
        this.tabelaUsuarios = getUserRows()

        const usuariosPaginados = this.tabelaUsuarios // .slice(this.pagination.pageStart, this.pagination.pageStop + 1)

        this.tableData = [this.tabelaDisponiveis, ...usuariosPaginados] // Acrescenta os "disponíveis" e os usuários na tableData
        this.tabelaTotais = getTotalsRow()
        this.tableData = [...this.tableData, this.tabelaTotais] // Acrescenta a linha TOTAIS na tableData. OBS: O total depende que os disponíveis e usuários estejam dentro da matriz tableData

        // [24/01/25] console.log('::: TABLE DATA:', this.tableData)
      },

      /**
      *
      * Separa informações do objeto de plantões (duties)
      *
      */

      getDataFromDuties (duties = [], name = '', options = this.options) {
        let qtd = 0
        let total = 0
        const days = []

        duties.forEach((duty) => {
          qtd++

          const day = parseInt(((duty.dutyStartDateTZ || '') === '+0000' ? moment.utc(duty.data_inicio) : moment(duty.data_inicio)).format('D'))

          const dutyDurationFormat = valueToTime(duty.periodo, true)
          const dutyDuration = timestrToSec(dutyDurationFormat)

          if (!!days[day] === true && !!days[day].durationInSeconds === true)
          {
            days[day].durationInSeconds += dutyDuration
            days[day].durationHourAndMinutes = days[day].durationInSeconds > 0 ? formatSecondsToTime(days[day].durationInSeconds) : ''
            days[day].formattedDurationHourAndMinutes = days[day].durationInSeconds > 0 ? formatDurationForTable(days[day].durationHourAndMinutes) : ''
          }
          else
          {
            const dutyDurationSecondsToTime = formatSecondsToTime(dutyDuration)

            days[day] = {
              durationInSeconds: dutyDuration,
              durationHourAndMinutes: dutyDuration > 0 ? dutyDurationSecondsToTime : '',
              formattedDurationHourAndMinutes: dutyDuration > 0 ? formatDurationForTable(dutyDurationSecondsToTime) : '',
              highlight: false,
            }
          }

          // days[day] = days[day] ? (days[day] += dutyDuration) : dutyDuration

          // console.log('[RelatorioModal] getDataFromDuties[day]:', day, days[day], dutyDurationFormat, dutyDuration)

          total += dutyDuration
        })

        // days = days.map(([day, value]) => this.formatSecondsToTime(value, false))

        // console.log('[RelatorioModal] getDataFromDuties[total]:', name, total, qtd, days)

        return {
          name,
          qtd,
          ...days,
          total,
          totalNumerico: 0,
          ...options,
        }
      },

      /**
      *
      *
      *
      */

      getAvailablesRow () {
        const { availableDutyFilter, getDataFromDuties } = this
        const duties = this.duties.filter((duty) => availableDutyFilter(duty))
        const data = getDataFromDuties(duties, 'Disponíveis')
        data.totalNumerico = data.total
        // console.log('getAvailablesRow[total]:', data.total)
        data.total = formatDuration(formatSecondsToTime(data.total, false), true) // + ' Horas'
        return data
      },

      /**
      *
      *
      *
      */

      getUserRow (user) {
        const { userDutyFilter } = this
        const duties = this.duties.filter((duty) => userDutyFilter(duty, user))
        const data = this.getDataFromDuties(duties, user.shortName)
        // const data = this.getDataFromDuties(duties, user.nome)
        // data.total = `${data.total} Horas`
        data.totalNumerico = data.total
        data.total = formatDuration(formatSecondsToTime(data.total, false), true) // + ' Horas'
        return data
      },

      /**
      *
      *
      *
      */

      getUserRows () {
        const { users, getUserRow } = this

        // [03/12/2020] Firmino
        let trataUsuarios = users.map((user) => getUserRow(user))

        // [03/12/2020] Firmino - Tarefa 1 [Ordenar quantidade de plantões realizados do maior para o menor]
        trataUsuarios = trataUsuarios.filter(a => a.qtd > 0)
        trataUsuarios.sort((a, b) => b.qtd - a.qtd)

        return trataUsuarios
      },

      /**
      *
      *
      *
      */

      getTotalsRow () {
        const { tableData, daysInMonth, options } = this

        // const tableTotal = tableData.reduce((a, b) => a + parseInt(b.total || 0), 0)
        // timestrToSec(valueToTime(tableData[0].totalnumerico))

        // TOTAL DOS PLANTÕES
        const tableTotal = tableData.reduce((a, b) => a + parseInt(b.totalNumerico || 0), 0)
        // TOTAL DOS PLANTÕES DISPONÍVEIS
        const tableTotalNumerico = tableData[0].totalNumerico
        // TOTAL DOS PLANTÕES - TOTAL DOS PLANTÕES DISPONÍVEIS
        const totalSemDisponiveis = tableTotal > tableTotalNumerico ? tableTotal - tableTotalNumerico : tableTotalNumerico - tableTotal

        // console.log('getTotalsRow:', tableTotal, tableTotalNumerico, totalSemDisponiveis)

        var total = {
          name: 'Total',
          qtd: tableData.reduce((a, b) => a + parseInt(b.qtd || 0), 0) - tableData[0].qtd,
          total: formatDuration(formatSecondsToTime(totalSemDisponiveis, false), true), // + ' Horas',
          totalNumerico: tableTotal,
          ...options,
        }

        const apenasUsuarios = tableData.slice(1, tableData.length)

        // Tarefa 1 - Firmino - Não soma horas disponíveis no total + Destaca o dia (em vermelho) quando houver horas disponíveis (nesse dia) que não foram trabalhadas
        daysInMonth.forEach(({ value: day }) => {
          const existeEmDisponiveis = !!tableData[0][day] === true && !!tableData[0][day].durationInSeconds === true ? tableData[0][day].durationInSeconds : 0
          const somaTodos = tableData.reduce((a, b) => a + (!!b[day] === true && !!b[day].durationInSeconds === true ? parseInt(b[day].durationInSeconds) : 0), 0)
          const somaApenasUsuarios = apenasUsuarios.reduce((a, b) => a + (!!b[day] === true && !!b[day].durationInSeconds === true ? parseInt(b[day].durationInSeconds) : 0), 0)

          const daySum = existeEmDisponiveis > 0 ? (somaTodos - existeEmDisponiveis) : somaTodos
          const daySumFormatted = formatSecondsToTime(daySum, false)

          total[day] = {
            durationInSeconds: daySum,
            durationHourAndMinutes: daySum > 0 ? daySumFormatted : '',
            formattedDurationHourAndMinutes: daySum > 0 ? formatDurationForTable(daySumFormatted) : '',
            highlight: somaApenasUsuarios > 0 && existeEmDisponiveis > 0,
          }
        })

        return total
      },
    },
  }

</script>

<style lang="scss">
  .dialogRelatorio {
    font-size: 0;
    // overflow: hidden;
  }

  .avisoNonPaid {
    border-radius: 7px;
    border: 1px solid #CFCFCF;
    padding: 10px 20px;
    box-shadow: 1px 1px 1px 1px #CFCFCF;
  }

</style>

<style lang="scss" scoped>

  .bgTotal {
    background-color: rgba(255, 255, 0, 0.1);

    td {
      span {
        font-size: 14px;
        // line-height: 20px;
      }
    }
  }

  .timeReportDialogBody {
    padding: 0;
    overflow-y: scroll;
    max-height: 400px;
    font-size: 16px;

    &::-webkit-scrollbar {
      width: 15px !important;
    }
  }

  //

  .relatorio-tables-wrap {
    min-width: 1780px;
    width: 100%;
    height: 100%;
    font-size: 0;
  }

  .relatorio-tables {
    display: inline-block;
    width: 100%;
    padding-top: 20px;
    // overflow-y: scroll;
  }

  //

  .rel-table-users {
    float: left;

    width: 14.487%;
    // width: 13.487%;
  }

  .rel-table-calendar {
    float: left;

    display: block;
    // width: 77.349%;
    width: 79.349%;
  }

  .rel-table-totalhoras {
    float: left;

    // width: 9.164%;
    width: 6.164%;
  }

  //

  @media (max-width: 1680px) {
    .relatorio-tables {
      width: 1680px;
    }
  }

  //

  .relatorio-pagination-wrap {
    width: 100%;
    padding-bottom: 15px;
    text-align: center;
  }

  //

  .rel-table-calendar table {
    width: 100%;
  }

  .rel-table-users th,
  .rel-table-calendar th,
  .rel-table-totalhoras th {
    font-size: 14px;
  }

  .rel-table-users td,
  .rel-table-calendar td,
  .rel-table-totalhoras td {
    font-size: 15px;
    line-height: 22px;
  }

  //

  .rel-table-users-th-top-cl1,
  .rel-table-users-th-top-cl2 {
    padding-top: 0;
    padding-bottom: 0;

    font-weight: 300;
    color: #ffffff;
  }

  .rel-table-users-th-bottom-cl1 {
    padding-left: 10px;
    padding-top: 0;
    padding-bottom: 7px;
  }
  .rel-table-users-th-bottom-cl2 {
    padding-top: 0;
    padding-bottom: 7px;

    text-align: center !important;
  }

  //

  .rel-table-totalhoras td,
  .rel-table-users td,
  .rel-table-users-th-bottom-cl1,
  .rel-table-users-th-bottom-cl2 {
    border-bottom: 1px solid #cecece;
  }

  .rel-table-users-cl2-first,
  .rel-table-users-cl2 {
    padding-top: 4px;
    padding-bottom: 4px;

    text-align: center !important;
  }

  .rel-table-users-cl1 span {
    display: inline-block;
    padding-left: 10px;

    color: rgba(0, 0, 0, 0.87);
    font-size: 13px;
    font-weight: bold;
  }

  //

  abbr[title] {
    border-bottom: none !important;
    cursor: default !important;
  }

  //

  .rel-table-totalhoras td,
  .rel-table-totalhoras th,
  .rel-table-users td,
  .rel-table-users th {
    text-align: left;
  }

  //

  .rel-table-calendar table td.highlight {
    background-color: #3cb371; // #4caf50;
    box-shadow: inset 2px 1px 7px 0px #228b22;
    border-left-color: #228b22;
    border-bottom-color: #228b22;

    color: #ffffff;
  }
  .rel-table-calendar table .highlight_red {
    color: #ff0000;
    font-weight: 600;
  }

  //

  .rel-table-calendar table td,
  .rel-table-totalhoras td {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  //

  .rel-table-totalhoras-th-top {
    padding-top: 0;
    padding-bottom: 0;
    font-weight: 300;
  }
  .rel-table-totalhoras-th-top span {
    color: #ffffff;
  }

  th.rel-table-totalhoras-th-bottom {
    padding-top: 0;
    padding-bottom: 7px;
    border-bottom: 1px solid #cecece;
  }

  .rel-table-totalhoras th span,
  .rel-table-totalhoras td span {
    display: inline-block;
    padding-left: 10px;
  }

  //

  /* .rel-table-calendar table td span,
  .rel-table-calendar table th span {
    display: inline-block;
  } */

  .rel-table-calendar table td,
  .rel-table-calendar table th {
    text-align: center;
  }
  .rel-table-calendar table th {
    min-width: 32px;
    width: 2.34374986vw;
  }

  //

  .relatorio-pagination {
    display: inline-block;
    padding-top: 15px;
  }

  //

  .rel-table-calendar-th-top {
    padding-top: 0;
    padding-bottom: 0;

    font-weight: 300;
  }

  .rel-table-calendar-th-bottom {
    padding-top: 0;
    padding-bottom: 7px;
    border-bottom: 1px solid #cecece;
  }

  .rel-table-calendar table th {
    border-left: 1px solid transparent;
  }
  .rel-table-calendar table th.last {
    border-right: 1px solid transparent;
  }

  .rel-table-calendar table td {
    border-bottom: 1px solid #cecece;
    border-left: 1px solid #efefef;
  }
  .rel-table-calendar table td.last {
    border-right: 1px solid #efefef;
  }

  //

  .qnt_disponiveis,
  .qnt_usuario {
    display: inline-block;
    width: 34px;
    height: 34px;
    padding-left: 0;
    // padding: 4px 12px; // 3px 10px;

    border-radius: 50%;

    line-height: 34px;
  }

  .qnt_disponiveis {
    background-color: #3cb371; // #4caf50;
    box-shadow: inset 2px 1px 7px 0px #228b22;

    color: #ffffff;
  }

  // <style>

  .v-dialog-imprimir .row {
    margin: 0 25px;
    padding: 15px 0;
  }

  .v-dialog-imprimir .col {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .v-dialog-report {
    height: 90%;
  }

  .v-dialog-report > .v-card {
    overflow: auto; /* rolagem horizontal para tabela abaixo de 1366 */
    height: 100%;
  }

  .v-dialog-imprimir .v-image {
    transition-property: filter;
    transition-duration: 300ms;

    cursor: pointer;
  }

  .v-dialog-imprimir .v-image.imgloading {
    filter: brightness(0.5);
  }

  .v-dialog-aviso .v-card__title {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.0071428571em;
  }

  .v-dialog-aviso .v-toolbar__title,
  .v-dialog-report .v-toolbar__title,
  .v-dialog-imprimir .v-toolbar__title {
    cursor: default;
    user-select: none;
  }

  .v-dialog-aviso .v-toolbar__items .v-icon,
  .v-dialog-report .v-toolbar__items .v-icon,
  .v-dialog-imprimir .v-toolbar__items .v-icon {
    margin-top: 0px !important;
    margin-right: 0px !important;
    color: #ffffff !important;
  }

  .v-dialog-imprimir .v-card__title {
    font-weight: 600 !important;
  }

  .v-dialog--h100 {
    height: 100% !important;
  }

  .v-dialog-textcenter {
    text-align: center;
  }

  .v-card--material > .d-flex {
    position: absolute;

    width: 100%;
  }

</style>
